import type { AppRouteRecordRaw } from '/@/router/types';
import { REDIRECT_NAME, LAYOUT, PAGE_NOT_FOUND_NAME, PAGE_UPDATE_NAME } from '/@/router/constant';
import { t } from '@mcex/locale';
import { PageEnum } from '/@/enums/pageEnum';
import { Error, UpdatePage } from '/@/views/sys/exception';
import { useAppStoreWithOut } from '/@/store/modules/app';
import { isChinaMainland } from '/@/api/sys/system';

// 404 on a page
export const PAGE_NOT_FOUND_ROUTE: AppRouteRecordRaw = {
  path: '/:path(.*)*',
  name: PAGE_NOT_FOUND_NAME,
  component: Error,
  meta: {
    title: 'ErrorPage',
    hideBreadcrumb: true,
    hideMenu: true,
  },
};

export const REDIRECT_ROUTE: AppRouteRecordRaw = {
  path: '/redirect',
  component: LAYOUT,
  name: 'RedirectTo',
  meta: {
    title: REDIRECT_NAME,
    hideBreadcrumb: true,
    hideMenu: true,
  },
  children: [
    {
      path: '/redirect/:path(.*)',
      name: REDIRECT_NAME,
      component: () => import('/@/views/sys/redirect/index.vue'),
      meta: {
        title: REDIRECT_NAME,
        hideBreadcrumb: true,
      },
    },
  ],
};

export const HomeRoute: AppRouteRecordRaw = {
  path: '',
  name: 'Index',
  component: LAYOUT,
  redirect: PageEnum.HOME,
  meta: {
    title: t('routes.basic.home'),
  },
  children: [
    {
      path: PageEnum.HOME,
      name: 'Home',
      component: () => import('/@/views/home/index.vue'),
      meta: {
        title: t('routes.dashboard.overview'),
        hideBreadcrumb: true,
        hideHeader: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
  ],
};

export const PAGE_UPDATE_ROUTE: AppRouteRecordRaw = {
  path: '/sys_update',
  name: PAGE_UPDATE_NAME,
  component: UpdatePage,
  meta: {
    title: t('sys.app.sysMaintenance'),
    hideBreadcrumb: true,
    hideMenu: true,
  },
  beforeEnter: (_to, from) => {
    const appStore = useAppStoreWithOut();
    if (appStore.getMaintenance === false) {
      return { path: from.path };
    }
    return true;
  },
};

/**
 * 问券调查-机构
 */

export const QuestionnaireRoute: AppRouteRecordRaw = {
  path: '/questionnaire',
  name: 'Questionnaire',
  component: () => import('/@/views/question/institution/index.vue'),
  meta: {
    title: t('routes.basic.questionnaire'),
  },
};

/**
 * 问券调查-个人
 */

export const QuestionnaireIpiRoute: AppRouteRecordRaw = {
  path: '/questionnaire-ipi',
  name: 'QuestionnaireIpi',
  component: () => import('/@/views/question/individual/index.vue'),
  meta: {
    title: t('routes.basic.questionnaireIpi'),
  },
  beforeEnter: (_to, _from) => {
    // console.log('beforeEnter');
    // 跳转到信息介绍
    return { path: '/information' };
  },
};
/**
 * 问券调查-企业
 */

export const QuestionnaireCpiRoute: AppRouteRecordRaw = {
  path: '/questionnaire-cpi',
  name: 'QuestionnaireCpi',
  component: () => import('/@/views/question/company/index.vue'),
  meta: {
    title: t('routes.basic.questionnaireCpi'),
  },
  beforeEnter: (_to, _from) => {
    // console.log('beforeEnter');
    // 跳转到信息介绍
    return { path: '/information' };
  },
};

/**
 * 问券调查-信息介绍
 */
export const QuestionnaireInfoRoute: AppRouteRecordRaw = {
  path: '/information',
  name: 'QuestionnaireInfo',
  component: () => import('/@/views/question/info/index.vue'),
  meta: {
    title: t('routes.basic.questionnaireInfo'),
  },
  beforeEnter: async (_to, _form, next) => {
    // 获取当前域名
    const domain = window.location.host;
    // 线上域名不是brokerage.mcex.mo的时候，重定向到brokerage.mcex.mo/#/portal/information
    if (['mt.microconnect.cc'].includes(domain)) {
      window.location.replace('https://brokerage.mcex.mo/portal/#/information');
      return;
    }
    const res = await isChinaMainland();
    if (res) {
      next(PageEnum.FORBIDDEN_PAGE + '?status=10101');
    } else {
      next();
    }
  },
};

// export const MarketPackageAssemblyRoute: AppRouteRecordRaw = {
//   path: '/market',
//   name: 'Market',
//   component: LAYOUT,
//   redirect: '/market/index',
//   meta: {
//     icon: 'menus-home|svg',
//     title: '市场',
//     hideChildrenInMenu: true,
//   },
//   children: [
//     {
//       path: 'index',
//       name: 'MarketIndex',
//       component: () => import('/@/views/home/index.vue'),
//       meta: {
//         // affix: true,
//         title: 'MarketIndex',
//         hideBreadcrumb: true,
//         currentActiveMenu: PageEnum.HOME,
//       },
//     },
//     {
//       path: 'packageAssembly',
//       name: 'PackageAssembly',
//       component: () => import('/@/views/market/packageAssembly/index.vue'),
//       meta: {
//         // affix: true,
//         title: '组合试算',
//         hideBreadcrumb: false,
//         currentActiveMenu: PageEnum.HOME,
//       },
//     },
//   ],
// };
